import PropTypes from 'prop-types';
import React from 'react';

import Date from '../../../common/date';
import Modal from '../../../common/Modal';
import Money from '../../../common/money';
import CurrencyInput from '../../../common/currencyInput';
import { getLastTopUp, getTopUpAmount } from '../../helpers';

const GiftCardModal = (props) => {
  const {
    modalOn,
    modalOff,
    modalIsOn,
    giftCard,
    handleSubmit,
  } = props;

  const lastTopUp = getLastTopUp(giftCard);

  return (
    <div className="u-inline-block" display-if={giftCard}>
      <button className="c-btn u-width-120" onClick={modalOn}>
        Top Up
      </button>
      <Modal
        display-if={modalIsOn}
        close={modalOff}
        title={(
          <span>
            Top Up Gift Card <code>{giftCard.code}</code>
          </span>
        )}
      >
        <div className="u-pv u-ph++">
          <div className="o-tableize">
            <div className="o-tableize__row">
              <div className="o-tableize__cell">
                <span className="c-label c-label--strong u-mr-">Date purchased:</span>
              </div>
              <div className="o-tableize__cell dark-mode-white">
                <Date>{giftCard.createdAt}</Date>
              </div>
            </div>
            <div className="o-tableize__row">
              <div className="o-tableize__cell">
                <span className="c-label c-label--strong u-mr-">Total top up value:</span>
              </div>
              <div className="o-tableize__cell dark-mode-white">
                <Money>{getTopUpAmount(giftCard)}</Money>
              </div>
            </div>
            <div className="o-tableize__row">
              <div className="o-tableize__cell">
                <span className="c-label c-label--strong u-mr-">Outstanding balance:</span>
              </div>
              <div className="o-tableize__cell dark-mode-white">
                <Money>{giftCard.outstandingBalance}</Money>
              </div>
            </div>
            <div className="o-tableize__row" display-if={!!lastTopUp}>
              <div className="o-tableize__cell u-pb" />
            </div>
            <div className="o-tableize__row" display-if={!!lastTopUp}>
              <div className="o-tableize__cell">
                <span className="c-label c-label--strong u-mr-">Amount of last top up:</span>
              </div>
              <div className="o-tableize__cell dark-mode-white">
                <Money>{lastTopUp.amount}</Money>
              </div>
            </div>
            <div className="o-tableize__row" display-if={!!lastTopUp}>
              <div className="o-tableize__cell">
                <span className="c-label c-label--strong u-mr-">Date of last top up:</span>
              </div>
              <div className="o-tableize__cell dark-mode-white">
                <Date>{lastTopUp.createdAt}</Date>
              </div>
            </div>
          </div>

          <form className="u-mt+ o-flexbox o-flexbox--justify-center" onSubmit={handleSubmit}>
            <div className="u-1/2-large-and-up">
              <span className="c-label-new u-block">Amount</span>
              <div className="c-input-group">
                <div className="u-flex-1">
                  <CurrencyInput
                    className="c-input c-input--white c-input-group__first u-1/1"
                    placeholder="Enter amount"
                    type="number"
                    pattern="[\d\.]*"
                    step="0.01"
                    name="amount"
                    format={val => parseInt(val, 10) || 0}
                  />
                </div>
                <button
                  type="submit"
                  className="c-btn c-btn--medium"
                >
                  <span className="c-btn__text">Charge</span>
                </button>
              </div>
            </div>
          </form>

          <div className="u-text-center u-mt+">
            <button className="c-btn c-btn--grey u-width-120" type="button" onClick={modalOff}>
              Cancel
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

GiftCardModal.propTypes = {
  modalOn: PropTypes.func.isRequired,
  modalOff: PropTypes.func.isRequired,
  modalIsOn: PropTypes.bool.isRequired,
  giftCard: PropTypes.shape({
    code: PropTypes.string,
    createdAt: PropTypes.string,
    initialBalance: PropTypes.number,
    outstandingBalance: PropTypes.number,
    lastUsedAt: PropTypes.string,
    deletedAt: PropTypes.string,
  }),
  handleSubmit: PropTypes.func.isRequired,
};

GiftCardModal.defaultProps = {
  giftCard: null,
};

export default GiftCardModal;
